





























// @ is an alias to /src
import { Component, Vue } from 'vue-property-decorator'
import Edit from '@/components/partenaire/edit/EditParamCw.vue'
import { AloPartenaire, getDefaultAloPartenaire } from '@/models/alo/AloPartenaire'
import { TypeOffre } from '@/enum/TypeOffre'
import { toSubArray } from '@/utils/groupBy'
import { PartRestrictFlag } from '@/enum/PartRestrictFlag'

@Component({
  name: 'ReadParamCw',    
  components:{Edit},  
  props: {
    loading:{
      type:Boolean,
      default:false
    },
    partenaire:{
      type:Object,
      default:getDefaultAloPartenaire()
    }
  }
})
export default class ReadParamCw extends Vue {
  
  private partenaire!:AloPartenaire
  private loading!:boolean

  edit() { 
    (this.$refs.edit as Edit).edit(this.partenaire)
  }


  get restrictionsAccesGroup() {    
    return toSubArray(Object.keys(PartRestrictFlag),6)
  }   

  get restricted(){
    return this.partenaire.ptnRestrictedFlag && this.partenaire.ptnRestrictedFlag.length >0 &&  this.partenaire.ptnRestrictedFlag != 'none'?this.partenaire.ptnRestrictedFlag.split(', '):[]
  } 
  
}
